import type { AdminUserDetail } from '@repo/api-contracts';
import type { ReactElement } from 'react';
import { socialProviderLabel } from '@/entities/user';
import { formatDateTime } from '@/shared/lib';
import { ContentCard } from '@/shared/ui';

interface UserLoginMethodsCardProps {
  readonly user: AdminUserDetail;
}

interface LoginMethod {
  readonly key: string;
  readonly label: string;
  readonly detail: string | null;
}

/** 로그인 수단 카드 — 비밀번호 계정이면 "이메일(비밀번호)", 소셜은 제공자 이름과 연결 시각. 탈퇴 계정은 비어 있을 수 있다. */
export const UserLoginMethodsCard = ({ user }: UserLoginMethodsCardProps): ReactElement => {
  const methods: readonly LoginMethod[] = [
    ...(user.hasPassword ? [{ key: 'password', label: '이메일(비밀번호)', detail: null }] : []),
    ...user.socialAccounts.map((account) => ({
      key: `${account.provider}-${account.linkedAt}`,
      label: socialProviderLabel(account.provider),
      detail: `연결 ${formatDateTime(account.linkedAt)}`,
    })),
  ];

  return (
    <ContentCard title="로그인 수단">
      {methods.length === 0 ? (
        <p className="text-sm text-muted-foreground">등록된 로그인 수단이 없습니다.</p>
      ) : (
        <ul aria-label="로그인 수단" className="flex flex-col gap-2 text-sm">
          {methods.map((method) => (
            <li key={method.key} className="flex flex-wrap items-baseline justify-between gap-x-3">
              <span>{method.label}</span>
              {method.detail ? (
                <span className="text-xs text-muted-foreground">{method.detail}</span>
              ) : null}
            </li>
          ))}
        </ul>
      )}
    </ContentCard>
  );
};
